module.exports = __webpack_public_path__ + "img/blog-img.5cb68dac.svg";